<div class="row" [class.reverse]="direction === 'reverse'">
  <div class="img">
    <ion-img [src]="imgPath"></ion-img>
  </div>
  <div class="ion-padding"></div>
  <div class="content">
    <span class="_number">{{ number }}</span>
    <h3 class="h3">{{title}}</h3>
    <p>{{content}}</p>
  </div>
</div>
